export const WAVE_BARS_CONFIG = [
	{ duration: 1.2, delay: 0.1, isEdge: true },
	{ duration: 0.8, delay: 0.2, isEdge: true },
	{ duration: 1.1, delay: 0.0, isEdge: false },
	{ duration: 0.6, delay: 0.3, isEdge: false },
	{ duration: 0.9, delay: 0.1, isEdge: false },
	{ duration: 0.7, delay: 0.4, isEdge: false },
	{ duration: 1.0, delay: 0.2, isEdge: false },
	{ duration: 0.8, delay: 0.0, isEdge: true },
	{ duration: 1.3, delay: 0.1, isEdge: true },
];

export const VOICE_CALL_WAVE_CONFIG = [
	{ duration: 0.9, delay: 0.0 },
	{ duration: 0.7, delay: 0.15 },
	{ duration: 1.0, delay: 0.05 },
	{ duration: 0.8, delay: 0.2 },
	{ duration: 0.95, delay: 0.1 },
];
